export function normalizeUrlPath(url: string): string {
  if (!url) return '/';

  let urlObject: URL;
  try {
    // Use 'http://example.com' as a base URL to support relative URLs
    urlObject = new URL(url, 'http://example.com');
  } catch (e) {
    console.error('Invalid URL:', e);
    return '/';
  }

  // Normalize pathname
  let pathname: string = urlObject.pathname;
  pathname = pathname.replace(/\/+/g, '/'); // Replace multiple slashes with a single slash
  if (pathname !== '/' && pathname.endsWith('/')) {
    pathname = pathname.slice(0, -1); // Remove trailing slash except for the root "/"
  }
  if (!pathname.startsWith('/')) {
    pathname = '/' + pathname; // Ensure leading slash
  }

  // Normalize query string
  let search: string = urlObject.search;
  search = search.replace(/\?&/, '?').replace(/^&/, ''); // Clean up leading ampersands
  search = search.replace(/&&/g, '&'); // Remove multiple ampersands

  // Combine normalized pathname and query string
  let normalizedUrl: string = pathname;
  if (search) {
    normalizedUrl += search;
  }

  return normalizedUrl;
}
